import React from "react";
import { useNavigate } from "react-router-dom";
const ContactUsBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="call-action text-center">
      <div
        className="background bg-img parallaxie pt-80 pb-80"
        data-background="/assets/img/bg2.png"
        data-overlay-dark={7}
      >
        <div className="container">
          <div className="row">
            <div className="offset-lg-3 col-lg-6 offset-md-2 col-md-8">
              <div>
                <h4>Let’s Connect and Collaborate Today</h4>
                <a
                  onClick={() => {
                    navigate("/contact");
                  }}
                  href="#0"
                  className="butn butn-bg mt-30"
                >
                  <span>
                    Contact Us
                    <i className="pe-7s-paper-plane" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsBanner;
